var ModulesForm = {
	Module: require('./modules/Module'),
	FormValidator: require('./modules/ModuleFormValidator'),
	Tooltips: require('./modules/ModuleTooltips'),
};

window.Modules = { ...window.Modules, ...ModulesForm };
